export default __webpack_public_path__ + "static/linear-transform-527373b04f6c4a5fedf3719c6fb5c370.png";